// Copyright (c) 2016 Deere & Company

import actions from '../../../customer/actions-list';

import {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';

export const resetCustomerDetails = () => ({
    data: getCustomerDefaultState(),
    type: actions.RESET_CUSTOMER_DETAILS
});



// WEBPACK FOOTER //
// ./src/product/new-transfer/action-creators/reset-customer-details.js